import { render } from "./file-picker.vue?vue&type=template&id=267ccec2&ts=true"
import script from "./file-picker.vue?vue&type=script&lang=ts"
export * from "./file-picker.vue?vue&type=script&lang=ts"
/* custom blocks */
import block0 from "./i18n/messages.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc3593438386%2Fsrc%2Fpadme-ui-aws%2Fapps%2Fmain%2Fsrc%2Fcomponents%2Ffile-uploader%2Ffile-picker.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__